'use strict';

angular.module('membership')
  .controller('CustomersListCtrl', [
    '$scope', 'customersListViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel();
      $scope.toggleOpen = function () {
        $scope.model.filterOpen = !$scope.model.filterOpen;
      };
    }
  ]);
